import axios from 'axios';
import React, { Component } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import MailOutlineRoundedIcon from '@material-ui/icons/MailOutlineRounded';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import VisibilityOffRoundedIcon from '@material-ui/icons/VisibilityOffRounded';
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';
import PhotoCameraRoundedIcon from '@material-ui/icons/PhotoCameraRounded';
import AccountBalanceRoundedIcon from '@material-ui/icons/AccountBalanceRounded';
import MapRoundedIcon from '@material-ui/icons/MapRounded';

import {
  validateLogin, apiList,
  validateEmail,
  validatePassword,
} from '../../helpers';
import { version } from '../../../package.json';
import { getUID } from '../../helpers/utils';

const Logo = require('../../assets/images/logo_long2.png').default;

const BRAND_POINTS = [
  { Icon: PhotoCameraRoundedIcon, text: 'Construction progress verified with geo-tagged site photos' },
  { Icon: AccountBalanceRoundedIcon, text: 'Disbursement requests reviewed in one queue' },
  { Icon: MapRoundedIcon, text: 'Every financed property on one map' },
];

class Login extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      error: null,
      success: null,
      email: '',
      password: '',
      emailClass: '',
      passwordClass: '',
      forgotPassword: false,
      resetPassword: false,
      ipAddress: '',
      forgotEmail: '',
      otp: '',
      rePassword: '',
      rerePassword: '',
      showPassword: false,
    };
  }

  componentDidMount() {
    this.getIp();
  }

  handleChange(key) {
    key.preventDefault();
    this.setState({
      error: null,
      success: null,
      emailClass: '',
      passwordClass: '',
      [key.target.id]: key.target.value,
    });
  }

  async handleLogin(key) {
    key.preventDefault();
    const {
      error, emailClass, passwordClass,
    } = validateLogin(this.state);

    if (error) {
      this.setState({
        error, emailClass, passwordClass,
      });
      return;
    }

    this.setState({ loading: true });

    const { email, password, ipAddress } = this.state;
    axios.post(apiList.LOGIN_API, {
      email,
      password,
      appVersion: version,
      deviceId: getUID(),
      ipAddress,
      osVersion: browserVersion,
      deviceName: browserName,
    })
      .then((response) => {
        localStorage.setItem('data', JSON.stringify(response.data));
        window.location.href = '/home';
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: err?.response?.data?.error || err?.response?.data?.message || 'Something went wrong. Please try again.',
        });
      });
  }

  getIp() {
    const that = this;
    try {
      fetch('https://api.ipify.org?format=json').then((res) => res.json()).then((data) => {
        if (data && data.ip) {
          that.setState({ ipAddress: data.ip });
        }
      }).catch((error) => console.log(error));
    } catch (e) {
      console.log(e);
    }
  }

  sendOtp = () => {
    const { forgotEmail } = this.state;
    const {
      error, emailClass,
    } = validateEmail(forgotEmail);

    if (error) {
      this.setState({
        error, emailClass,
      });
      return;
    }

    this.setState({ loading: true });
    axios.post(`${apiList.FORGOT_PASSWORD}`, {
      email: forgotEmail,
    })
      .then((response) => {
        this.setState({ loading: false, resetPassword: true, forgotPassword: false });
        if (response) {
          this.setState({ success: 'We have emailed you a one-time code.' });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: err?.response?.data?.error || err?.response?.data?.message || 'Something went wrong. Please try again.',
        });
      });
  };

  resetPassword = () => {
    const {
      forgotEmail, otp, rePassword, rerePassword,
    } = this.state;
    if (otp.length < 6) {
      this.setState({ error: 'OTP must be 6 digit long.' });
      return;
    }
    const {
      error, passwordClass,
    } = validatePassword(rePassword);
    if (error) {
      this.setState({
        error, passwordClass,
      });
      return;
    }
    if (rePassword !== rerePassword) {
      this.setState({
        error: 'Password should be same.', passwordClass,
      });
      return;
    }

    this.setState({ loading: true });
    axios.post(`${apiList.RESET_PASSWORD}`, {
      email: forgotEmail,
      otp,
      password: rePassword,
    })
      .then((response) => {
        this.setState({
          loading: false,
          resetPassword: false,
          forgotEmail: '',
          otp: '',
          rePassword: '',
        });
        if (response) {
          this.setState({ success: 'Password updated. Sign in with your new password.' });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: err?.response?.data?.error || err?.response?.data?.message || 'Something went wrong. Please try again.',
        });
      });
  };

  backToSignIn = () => {
    this.setState({
      forgotPassword: false,
      resetPassword: false,
      success: null,
      error: null,
      forgotEmail: '',
      otp: '',
      rePassword: '',
      rerePassword: '',
    });
  };

  renderAlerts() {
    const { error, success } = this.state;
    return (
      <>
        {error ? <div className='form-alert error' role='alert'>{error}</div> : null}
        {success ? <div className='form-alert success' role='status'>{success}</div> : null}
      </>
    );
  }

  renderField({
    id, label, labelAction, type, value, Icon, invalid,
    autoComplete, placeholder, inputMode, toggle,
  }) {
    const { showPassword } = this.state;
    const isSecret = type === 'password';
    return (
      <div className='form-field'>
        <div className='label-row'>
          <label className='field-label' htmlFor={id}>{label}</label>
          {labelAction}
        </div>
        <div className={`field${invalid ? ' invalid' : ''}`}>
          <Icon className='field-icon' />
          <input
            id={id}
            type={isSecret && showPassword ? 'text' : type}
            value={value}
            placeholder={placeholder}
            autoComplete={autoComplete}
            inputMode={inputMode}
            onChange={(e) => this.handleChange(e)}
          />
          {isSecret && toggle ? (
            <button
              type='button'
              className='field-toggle'
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              onClick={() => this.setState({ showPassword: !showPassword })}
            >
              {showPassword ? <VisibilityOffRoundedIcon /> : <VisibilityRoundedIcon />}
            </button>
          ) : null}
        </div>
      </div>
    );
  }

  renderSubmit(label, busyLabel) {
    const { loading } = this.state;
    return (
      <button type='submit' className='primary-button' disabled={loading}>
        {loading ? (
          <>
            <span className='spinner' aria-hidden='true' />
            {busyLabel}
          </>
        ) : label}
      </button>
    );
  }

  renderSignIn() {
    const {
      email, password, emailClass, passwordClass,
    } = this.state;
    return (
      <>
        <h1 className='card-title card-title-solo'>Welcome back</h1>
        <form className='login-form' noValidate onSubmit={(e) => this.handleLogin(e)}>
          {this.renderAlerts()}
          {this.renderField({
            id: 'email', label: 'Email', type: 'email', value: email, Icon: MailOutlineRoundedIcon, invalid: !!emailClass, autoComplete: 'username', placeholder: 'name@company.com',
          })}
          {this.renderField({
            id: 'password',
            label: 'Password',
            labelAction: (
              <button
                type='button'
                className='link-button'
                onClick={() => this.setState({ forgotPassword: true, error: null, success: null })}
              >
                Forgot password?
              </button>
            ),
            type: 'password',
            value: password,
            Icon: LockOutlinedIcon,
            invalid: !!passwordClass,
            autoComplete: 'current-password',
            placeholder: 'Enter your password',
            toggle: true,
          })}
          {this.renderSubmit('Sign in', 'Signing in…')}
        </form>
      </>
    );
  }

  renderForgot() {
    const { forgotEmail, emailClass } = this.state;
    return (
      <>
        <button type='button' className='back-link' onClick={this.backToSignIn}>
          <ArrowBackRoundedIcon />
          Back to sign in
        </button>
        <h1 className='card-title'>Reset your password</h1>
        <p className='card-subtitle'>Enter your account email and we&apos;ll send you a one-time code.</p>
        <form className='login-form' noValidate onSubmit={(e) => { e.preventDefault(); this.sendOtp(); }}>
          {this.renderAlerts()}
          {this.renderField({
            id: 'forgotEmail', label: 'Email', type: 'email', value: forgotEmail, Icon: MailOutlineRoundedIcon, invalid: !!emailClass, autoComplete: 'username', placeholder: 'name@company.com',
          })}
          {this.renderSubmit('Send code', 'Sending…')}
        </form>
      </>
    );
  }

  renderReset() {
    const {
      otp, rePassword, rerePassword, passwordClass,
    } = this.state;
    return (
      <>
        <button type='button' className='back-link' onClick={this.backToSignIn}>
          <ArrowBackRoundedIcon />
          Back to sign in
        </button>
        <h1 className='card-title'>Set a new password</h1>
        <p className='card-subtitle'>Enter the 6-digit code from your email, then choose a new password.</p>
        <form className='login-form' noValidate onSubmit={(e) => { e.preventDefault(); this.resetPassword(); }}>
          {this.renderAlerts()}
          {this.renderField({
            id: 'otp', label: 'One-time code', type: 'text', value: otp, Icon: VpnKeyOutlinedIcon, autoComplete: 'one-time-code', placeholder: '6-digit code', inputMode: 'numeric',
          })}
          {this.renderField({
            id: 'rePassword', label: 'New password', type: 'password', value: rePassword, Icon: LockOutlinedIcon, invalid: !!passwordClass, autoComplete: 'new-password', placeholder: 'New password', toggle: true,
          })}
          {this.renderField({
            id: 'rerePassword', label: 'Confirm new password', type: 'password', value: rerePassword, Icon: LockOutlinedIcon, invalid: !!passwordClass, autoComplete: 'new-password', placeholder: 'Repeat new password',
          })}
          {this.renderSubmit('Update password', 'Updating…')}
        </form>
      </>
    );
  }

  render() {
    const { forgotPassword, resetPassword } = this.state;
    let content = this.renderSignIn();
    if (forgotPassword) content = this.renderForgot();
    else if (resetPassword) content = this.renderReset();

    return (
      <div className='login-component'>
        <aside className='login-brand'>
          <div className='brand-pattern' aria-hidden='true'>
            <span />
            <span />
            <span />
            <span />
          </div>
          <img className='brand-logo' src={Logo} alt='BrickEZ' />
          <div className='brand-copy'>
            <h2>Construction finance, tracked from plan to disbursement.</h2>
            <ul className='brand-points'>
              {BRAND_POINTS.map(({ Icon, text }) => (
                <li key={text}>
                  <span className='point-icon'><Icon /></span>
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className='brand-footer'>{`© ${new Date().getFullYear()} BrickEZ by HomeHub`}</div>
        </aside>

        <main className='login-panel'>
          <div className='login-card'>
            <img className='card-logo' src={Logo} alt='BrickEZ' />
            {content}
          </div>
        </main>
      </div>
    );
  }
}

export default Login;
